/**
* 左边菜单
*/
<template>
  <el-menu default-active="2" :collapse="collapsed" collapse-transition router :default-active="$route.path" unique-opened class="el-menu-vertical-demo" background-color="#334157" text-color="#fff" active-text-color="#ffd04b">
    <div class="logobox" v-show="!collapsed">
      <i class="el-icon-phone-outline"></i> 客户服务平台
    </div>
    <div class="logobox" v-show="collapsed"></div>
    <el-menu-item index="/base/index">
      <i class="el-icon-s-home"></i>
      <span>首页</span>
    </el-menu-item>
    <el-submenu v-if="menu.menus" :index="menu.menuname" v-for="menu in allmenu" :key="menu.menuid">
      <template slot="title">
        <i :class="menu.icon"></i>
        <span>{{menu.menuname}}</span>
      </template>
      <el-menu-item-group v-if="menu.menus">
        <el-menu-item v-for="chmenu in menu.menus" :index="'/'+chmenu.url" :key="chmenu.menuid">
          <i :class="chmenu.icon"></i>
          <span>{{chmenu.menuname}}</span>
        </el-menu-item>
      </el-menu-item-group>
    </el-submenu>
    <el-menu-item :index="'/'+menu.url" :key="menu.menuid" v-else>
      <i :class="menu.icon"></i>
      <span>{{menu.menuname}}</span>
    </el-menu-item>
  </el-menu>
</template>
<script>
import { menuList } from '../api/baseset'
export default {
  name: 'leftnav',
  data() {
    return {
      collapsed: false,
      allmenu: []
    }
  },
  // 创建完毕状态(里面是操作)
  created() {
    menuList().then(res => {
      this.allmenu = res.data
    })
    .catch(err => {
      this.$message.error('菜单加载失败，请稍后再试！')
    })

    this.$root.Bus.$on('toggle', value => {
      this.collapsed = !value
    })
  }
}
</script>
<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 240px;
  min-height: 400px;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
  text-align: left;
}
.el-menu-item-group__title {
  padding: 0px;
}
.el-menu-bg {
  background-color: #1f2d3d !important;
}
.el-menu {
  border: none;
}
.logobox {
  height: 40px;
  line-height: 40px;
  color: #0981fd;
  font-size: 24px;
  font-weight: bold;
  text-align: center;
  padding: 20px 0px;
}
.logoimg {
  height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/leftnav.vue